import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Modal, Col } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import $ from "jquery";
import StudentController from "../api/StudentController";

interface FeedbackState
{
    show: boolean;
    rating: any;
}

interface FeedbackProps
{
    footer: boolean;
}

class Feedback extends React.Component<FeedbackProps, FeedbackState>
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);

        this.studentController = new StudentController();

        this.state = {
            show: false,
            rating: 0
        };
    }

    changeRating(newRating)
    {
        this.setState({
            rating: newRating
        });
    }

    clickShowFeedback()
    {
        this.setState({ show: true });
    }

    render()
    {
        const handleClose = () => this.setState({ show: false });

        const submitFeedback = () =>
        {
            $("#feedback_right").hide();
            $("#sendingFeedback").fadeIn();

            const feedbackData = {
                name: $("#name").val(),
                email: $("#email").val(),
                rating: this.state.rating.toString(),
                feedback: $("#messageBox").val(),
                url: location.href,
                userAgent: navigator.userAgent
            };

            this.studentController.sendFeedback(feedbackData);

            $("#feedback_right").hide();
            $("#sendingFeedback").hide();
            $("#doneFeedback").fadeIn();
        };

        return (
            <Fragment>
                {
                    this.props.footer
                        ?
                        <button className={"feedback-footer button-empty"} onClick={() => this.clickShowFeedback()} tabIndex={0}><a>Feedback</a></button>
                        :
                        <button id="floating_link" className="hidden-xs button-empty" onClick={() => this.clickShowFeedback()} tabIndex={0}>Feedback</button>
                }

                <Modal className="modal fade" centered show={this.state.show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title className="modal-title">We'd love to hear from you!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <div id="feedback_right">
                            <input type="hidden" id="userAgent" name="userAgent" value="" />
                            <input type="hidden" id="url" name="url" value="" />
                            <div className="form-group">
                                <label>Name</label>
                                <input id="name" value={this.props.user.fullName} name="name" type="text" title="e.g. Jane Smith" className="form-control" disabled />
                            </div>
                            <div className="form-group">
                                <label>E-mail</label>
                                <input id="email" name="email" value={this.props.user.kerbId ? this.props.user.kerbId + "@mit.edu" : ""} type="text" title="e.g. jsmith@mit.edu" className="form-control" disabled />
                            </div>
                            <div className="form-group">
                                <label>How would you rate the Canopy site?</label>
                                <div>
                                    <StarRatings
                                        rating={this.state.rating}
                                        starRatedColor="gold"
                                        changeRating={(e) => this.changeRating(e)}
                                        numberOfStars={5}
                                        name='rating'
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Comments, Suggestions or Feedback</label>
                                <textarea id="messageBox" name="messageBox" rows="3" className="form-control"></textarea>
                            </div>
                            <div className={"feedback-dialog-footer mt-3"}>
                                <button type="button" onClick={submitFeedback} className="btn btn-secondary">Send Feedback</button>
                            </div>
                        </div>

                        <div id="sendingFeedback" className={"sendingFeedback"}>
                            <h2 className={"feedbackHeading"}>Please wait...</h2>
                            <div className={"fdbckldr"} id="fdbckldr">
                            </div>
                        </div>
                        <div id="doneFeedback" className={"doneFeedback"}>
                            <h2 className={"feedbackHeading"}>Your Feedback has been submitted! Thank you!</h2>
                            <button type="button" onClick={handleClose} className="btn btn-primary">Close</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </Fragment>
        );
    }
}

const mapStateToProps = (state: any) => ({
    user: state.app.user
});

export default connect(mapStateToProps)(Feedback);